module.exports = __webpack_public_path__ + "static/media/for-investors-forth.1edb4685.jpg";